import { PROJECT_VARIABLES } from './project_variables';

export const environment = {
    production: false,
    ENV: PROJECT_VARIABLES.environments.ACCEPTANCE,
    API_SERVER: PROJECT_VARIABLES.api_server.ACCEPTANCE,
    SENTRY_DNS: PROJECT_VARIABLES.SENTRY_DNS,
    SEGMENT_API_KEY: PROJECT_VARIABLES.segment_api_key.ACCEPTANCE,
    IMAGE_BUCKET: `https://s3-eu-west-1.amazonaws.com/${PROJECT_VARIABLES.aws_domains.ACCEPTANCE}`,
    DEFAULT_LOCALE: 'en-US',
    LOCALES: [
        {
            name: 'English',
            code: 'en-US'
        },
        {
            name: 'Nederlands',
            code: 'nl-NL'
        },
        {
            name: 'Français',
            code: 'fr-BE'
        },
        {
            name: 'Deutsch',
            code: 'de-DE'
        }
    ],
    ENVIRONMENTS: {
        LOCAL: 'local',
        DEVELOPMENT: 'development',
        DEVELOPMENT_PD: 'development-pd',
        ACCEPTANCE: 'acceptance',
        PRODUCTION: 'production'
    },
    OIDC: {
        redirectUri: window.location.origin + '/auth/oidc/callback',
        postLogoutRedirectUri: window.location.origin,
        responseType: 'code',
        scope: 'openid profile email',
        automaticSilentRenew: true,
        monitorSession: false,
        loadUserInfo: true,
        silentRedirectUri: undefined,
        extraAuthorizeParams: {
            audience: PROJECT_VARIABLES.auth0_audience.ACCEPTANCE
        },
        defaultRedirectTarget: '/'
    },
    OAUTH_CLIENT_ID: PROJECT_VARIABLES.oauth_client_id
};
